"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applySetupTests = void 0;
var timer_tester_1 = require("./timer-tester");
var applySetupTests = function () {
    // In Node v7 unhandled promise rejections will terminate the process
    if (!process.env.LISTENING_TO_UNHANDLED_REJECTION) {
        process.on('unhandledRejection', function (reason) {
            process.env.LISTENING_TO_UNHANDLED_REJECTION = 'true';
            throw reason;
        });
        // Avoid memory leak by adding too many listeners
        process.env.LISTENING_TO_UNHANDLED_REJECTION = 'true';
    }
    beforeEach(function () {
        timer_tester_1.timerTester.beforeTest();
    });
    afterEach(function () {
        timer_tester_1.timerTester.afterTest();
    });
};
exports.applySetupTests = applySetupTests;
